<template>
  <ContainerPage class="EventNotFound">
    <LayoutFill>
      <LayoutCenter>
        <v-div display-1 pa-4 foreground-error>
          <span>Sorry, the event you are looking for</span>
          <br />
          <span>cannot be found.</span>
        </v-div>
      </LayoutCenter>
    </LayoutFill>
  </ContainerPage>
</template>

<script>
import ContainerPage from "~/components/layout/ContainerPage.vue";
import LayoutFill from "~/components/layout/LayoutFill.vue";
import LayoutCenter from "~/components/layout/LayoutCenter.vue";

export default {
  name: "EventNotFound",
  components: {
    ContainerPage,
    LayoutFill,
    LayoutCenter,
  },
  middleware: ["ensureUserLoaded"],
};
</script>
